/** Pure affiliate rules (tested in affiliate-rules.test.js). */
export { isAffiliateTestOrder, partnerRevenueCents } from "../../supabase/functions/_shared/affiliate-test-orders";
export type AffiliateSource = 'link' | 'code';
export interface Attribution { slug: string; name: string; source: AffiliateSource; at: number }

export const ATTRIBUTION_DAYS = 30;

/** Short-link slug: lowercase, no umlauts or spaces; input case does not matter. */
export function normalizeSlug(raw: string | null | undefined): string | null {
  const s = (raw ?? '').trim().toLowerCase();
  return /^[a-z0-9-]{2,40}$/.test(s) ? s : null;
}

/**
 * Last click wins: a newer attribution replaces the previous one. The link's
 * own code (auto-applied after a short link) keeps the attribution type "link".
 */
export function nextAttribution(prev: Attribution | null, incoming: Attribution): Attribution {
  if (prev && prev.slug === incoming.slug && prev.source === 'link' && incoming.source === 'code') {
    return { ...prev, at: incoming.at };
  }
  return incoming;
}

export function isExpired(a: Attribution, now = Date.now()): boolean {
  return now - a.at > ATTRIBUTION_DAYS * 24 * 60 * 60 * 1000;
}

/** Commission in cents: none for refunded orders. */
export function commissionCents(netCents: number, percent: number, refunded: boolean, isTest = false): number {
  return refunded || isTest ? 0 : Math.round(netCents * percent / 100);
}
